import React from "react";
import {
  Box,
  Flex,
  Grid,
  Text,
  VStack,
  Link as ChakraLink,
  Image,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import {
  FaInstagram,
  FaLinkedin,
  FaXTwitter,
  FaFacebook,
  FaYoutube,
  FaEnvelope,
  FaPinterest,
} from "react-icons/fa6";
import logo from "../../assets/header/logo.png";

const Footer = () => {
  const navigate = useNavigate();
  const handleSizeGuideClick = () => {
    navigate("/jewellery-care", { state: { tabIndex: 2 } });
  };
  return (
    <Box bg="#071F1E" color="white" px={{ base: 10, md: 32 }} py={12}>
      <Grid
        templateColumns={{ base: "1fr", md: "repeat(4, 1fr)" }}
        gap={20}
        textAlign="left"
      >
        {/* LOGO + INFO */}
        <Box>
          <Image src={logo} alt="R'RUMI DIAMOND logo" mb={4} maxW="150px" />
          <Text fontWeight="semibold" mt={12}>
            Follow us on
          </Text>
          <Flex justify="left" mt={10} gap={6} flexWrap="wrap">
            <ChakraLink
              href="https://www.instagram.com/rrumidiamond/#"
              isExternal
              aria-label="Instagram"
              color="white"
            >
              <FaInstagram size={16} />
            </ChakraLink>
            <ChakraLink
              href="https://www.facebook.com/rrumidiamond/"
              isExternal
              aria-label="Facebook"
              color="white"
            >
              <FaFacebook size={16} />
            </ChakraLink>
            <ChakraLink
              href="https://www.youtube.com/@Rrumidiamond"
              isExternal
              aria-label="YouTube"
              color="white"
            >
              <FaYoutube size={16} />
            </ChakraLink>
            <ChakraLink
              href="https://www.pinterest.com/rrumiaccessories/"
              isExternal
              aria-label="Pinterest"
              color="white"
            >
              <FaPinterest size={16} />
            </ChakraLink>
            <ChakraLink
              href="https://x.com/rrumidiamond"
              isExternal
              aria-label="X"
              color="white"
            >
              <FaXTwitter size={16} />
            </ChakraLink>
            <ChakraLink
              href="mailto:rrumismm@gmail.com"
              isExternal
              aria-label="Email"
              color="white"
            >
              <FaEnvelope size={16} />
            </ChakraLink>
            <ChakraLink
              href="https://www.linkedin.com/company/rrumidiamond/"
              isExternal
              aria-label="LinkedIn"
              color="white"
            >
              <FaLinkedin size={16} />
            </ChakraLink>
          </Flex>
        </Box>

        {/* MENU */}
        <VStack align="start" spacing={2}>
          <Text fontSize="lg" fontWeight="bold" mb={2}>
            CONTACT HUB
          </Text>
          <ChakraLink href="/about-us">About Us</ChakraLink>
          <ChakraLink href="/store">Store Locator</ChakraLink>
          {/* <ChakraLink href="/contact-us">Contact Us</ChakraLink> */}
          <ChakraLink href="/appointment">Book An Appointment</ChakraLink>
          <ChakraLink href="/fandq">FAQ</ChakraLink>
        </VStack>

        {/* SUPPORT */}
        <VStack align="start" spacing={2}>
          <Text fontSize="lg" fontWeight="bold" mb={2}>
            SUPPORT
          </Text>
          <ChakraLink href="/services">Our Services</ChakraLink>
          <ChakraLink href="/blogs">Blog</ChakraLink>
          {/* <ChakraLink href="/discover-collection">Our collection</ChakraLink> */}
          <ChakraLink onClick={handleSizeGuideClick} cursor="pointer">
            Size Guide
          </ChakraLink>

          <ChakraLink href="/franchise">Franchise Enquiry</ChakraLink>
        </VStack>

        {/* PRIVACY & LEGAL */}
        <VStack align="start" spacing={2}>
          <Text fontSize="lg" fontWeight="bold" mb={2}>
            PRIVACY & LEGAL
          </Text>
          <ChakraLink href="/privacypolicy">Our Policies</ChakraLink>
          <ChakraLink href="/custom">Customs And Duties</ChakraLink>
          <ChakraLink href="/termsandcondition">Terms And Condition</ChakraLink>
          <ChakraLink href="/cancellation">Refund And Cancellation</ChakraLink>
        </VStack>
      </Grid>

      {/* BOTTOM STRIP */}
      <Box
        mt={10}
        pt={4}
        borderTop="1px solid"
        borderColor="whiteAlpha.300"
        textAlign="start"
      >
        <Text fontSize="sm" mb={1}>
          Change country/Region - United Arab Emirates
        </Text>
      </Box>

      <Box mt={4} pt={4} textAlign="center">
        <Text fontSize="sm">
          © 2025 All rights reserved by Rrumidiamond PRIVATE LIMITED
        </Text>
      </Box>
    </Box>
  );
};

export default Footer;
